module.exports = __webpack_public_path__ + "static/img/honor18.50bcc39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor18.png
// module id = F8Rq
// module chunks = 0